// enum.ts
var FeedType = /* @__PURE__ */ ((FeedType2) => {
  FeedType2["follow"] = "\u5173\u6CE8";
  FeedType2["score"] = "\u8BC4\u5206";
  FeedType2["evaluate"] = "\u8BC4\u4EF7";
  FeedType2["add"] = "\u6DFB\u52A0\u4E86";
  FeedType2["update"] = "\u66F4\u65B0\u4E86";
  FeedType2["add_friend"] = "\u5C06";
  FeedType2["feed"] = "\u8BF4";
  FeedType2["up"] = "\u8D5E\u4E86";
  FeedType2["down"] = "\u8E29\u4E86";
  FeedType2["comment"] = "\u8BC4\u8BBA\u4E86";
  FeedType2["reply"] = "\u56DE\u590D\u4E86";
  FeedType2["share"] = "\u5206\u4EAB\u4E86";
  FeedType2["bookmark"] = "\u52A0\u5165\u4E66\u7B7E";
  FeedType2["favourite"] = "\u6536\u85CF\u4E86";
  FeedType2["forward"] = "\u8F6C\u53D1\u4E86";
  FeedType2["delete"] = "\u5220\u9664";
  return FeedType2;
})(FeedType || {});
var statusType = {
  normal: { text: "\u6B63\u5E38", status: "Success" },
  disable: { text: "\u7981\u7528", status: "Error" },
  check: { text: "\u5BA1\u6838", status: "Processing" },
  reject: { text: "\u62D2\u7EDD", status: "Warning" },
  ignore: { text: "\u5FFD\u7565", status: "Warning" },
  delete: { text: "\u5220\u9664", status: "Default" }
};
var feedTypeBig = /* @__PURE__ */ ((feedTypeBig2) => {
  feedTypeBig2["ADD"] = "add";
  feedTypeBig2["UPDATE"] = "update";
  feedTypeBig2["UP"] = "up";
  feedTypeBig2["FAVOURITE"] = "favourite";
  feedTypeBig2["FEED"] = "feed";
  feedTypeBig2["BOOKMARK"] = "bookmark";
  feedTypeBig2["ADD_FRIEND"] = "add_friend";
  feedTypeBig2["REPLY"] = "reply";
  feedTypeBig2["SHARE"] = "share";
  feedTypeBig2["DOWN"] = "down";
  feedTypeBig2["DELETE"] = "delete";
  return feedTypeBig2;
})(feedTypeBig || {});
var modelName = /* @__PURE__ */ ((modelName2) => {
  modelName2[modelName2["SITE"] = 1] = "SITE";
  modelName2[modelName2["NEWS"] = 2] = "NEWS";
  modelName2[modelName2["FAVOURITE"] = 3] = "FAVOURITE";
  modelName2[modelName2["TAG"] = 4] = "TAG";
  modelName2[modelName2["FEED"] = 5] = "FEED";
  modelName2[modelName2["TOPIC"] = 6] = "TOPIC";
  modelName2[modelName2["LISTS"] = 7] = "LISTS";
  modelName2[modelName2["USER"] = 8] = "USER";
  modelName2[modelName2["BOOKMARK"] = 9] = "BOOKMARK";
  modelName2[modelName2["CHANGES"] = 10] = "CHANGES";
  modelName2[modelName2["ATTACHMENT"] = 11] = "ATTACHMENT";
  modelName2[modelName2["HOME"] = 12] = "HOME";
  modelName2[modelName2["LIST"] = 13] = "LIST";
  return modelName2;
})(modelName || {});
var sidName = {
  [1 /* SITE */]: "site",
  [2 /* NEWS */]: "news",
  [4 /* TAG */]: "tag",
  [5 /* FEED */]: "feed",
  [6 /* TOPIC */]: "topic",
  [7 /* LISTS */]: "lists",
  [9 /* BOOKMARK */]: "bookmark",
  [8 /* USER */]: "user",
  [10 /* CHANGES */]: "changes",
  [11 /* ATTACHMENT */]: "attachment",
  [12 /* HOME */]: "home",
  [13 /* LIST */]: "list"
};
var modelEnName = {
  [1 /* SITE */]: "Site",
  [2 /* NEWS */]: "News",
  [4 /* TAG */]: "Tag",
  [5 /* FEED */]: "Feed",
  [6 /* TOPIC */]: "Topic",
  [7 /* LISTS */]: "Lists",
  [8 /* USER */]: "User",
  [9 /* BOOKMARK */]: "Bookmark",
  [10 /* CHANGES */]: "Changes",
  [11 /* ATTACHMENT */]: "Attachment",
  [12 /* HOME */]: "Home",
  [13 /* LIST */]: "List"
};
var modelType = {
  [1 /* SITE */]: "\u7F51\u5740",
  [2 /* NEWS */]: "\u65B0\u95FB",
  [4 /* TAG */]: "\u6807\u7B7E",
  [5 /* FEED */]: "\u52A8\u6001",
  [6 /* TOPIC */]: "\u8BDD\u9898",
  [7 /* LISTS */]: "\u6E05\u5355",
  [8 /* USER */]: "\u7528\u6237",
  [9 /* BOOKMARK */]: "\u4E66\u7B7E",
  [10 /* CHANGES */]: "\u5386\u53F2",
  [11 /* ATTACHMENT */]: "\u9644\u4EF6",
  [12 /* HOME */]: "\u9996\u9875",
  [13 /* LIST */]: "\u5206\u7C7B"
};
var feedType = /* @__PURE__ */ ((feedType2) => {
  feedType2["ADD"] = "add";
  feedType2["UPDATE"] = "update";
  feedType2["UP"] = "up";
  feedType2["FAVOURITE"] = "favourite";
  feedType2["BOOKMARK"] = "bookmark";
  feedType2["SEASON"] = "season";
  feedType2["FEED"] = "feed";
  feedType2["ADD_FRIEND"] = "add_friend";
  feedType2["DELETE"] = "delete";
  return feedType2;
})(feedType || {});
var type = ["\u7F51\u7AD9", "H5", "\u5C0F\u7A0B\u5E8F", "\u514D\u8D39", "\u4ED8\u8D39", "\u5185\u8D2D", "App", "\u5BA2\u6237\u7AEF", "Chrome\u6269\u5C55"];
export {
  FeedType,
  feedType,
  feedTypeBig,
  modelEnName,
  modelName,
  modelType,
  sidName,
  statusType,
  type
};
